import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* uploadFile(action) {
  const successAction= `${action.genericAction}.SUCCESS`
  const failureAction= `${action.genericAction}.FAILURE`

  try {
    const {file, key} = action.payload;
    const form = new FormData();
    form.append('file', file);
    form.append('key', key);
    const fileDescription = yield call(function () {
      return Api.post('/upload', form);
    });
    yield put({type: successAction, key, fileDescription, ...action.payload});
  } catch (error) {
    yield put({type: failureAction, error})
  }
}

function* deleteFile(action) {
  const successAction= `${action.genericAction}.SUCCESS`
  const failureAction= `${action.genericAction}.FAILURE`
  try {
    // We don't need to delete the file physically, if we do, we might have a reference to a file that does not exists anymore
    //yield call(function () {
    //  return Api.post('/delete?key='+key);
    //});

    yield put({type: successAction, ...action.payload});
  } catch (error) {
    yield put({type: failureAction, error})
  }
}

export function* watchUploadFile() {
  yield takeEvery('SAVE.GENERAL_CONDITION_FILE.REQUEST', (action)=>uploadFile({...action, genericAction:"SAVE.GENERAL_CONDITION_FILE"}));
  yield takeEvery('DELETE.GENERAL_CONDITION_FILE.REQUEST', (action)=>deleteFile({...action, genericAction:"DELETE.GENERAL_CONDITION_FILE"}));

  yield takeEvery('SAVE.BANNER_CONFIGURATION_FILE.REQUEST', action => uploadFile({...action, genericAction: 'SAVE.BANNER_CONFIGURATION_FILE'}));
  yield takeEvery('DELETE.BANNER_CONFIGURATION_FILE.REQUEST', action => deleteFile({...action, genericAction: 'DELETE.BANNER_CONFIGURATION_FILE'}));

  yield takeEvery('SAVE.COMMUNICATION_BACKGROUND_FILE.REQUEST', action => uploadFile({...action, genericAction: 'SAVE.COMMUNICATION_BACKGROUND_FILE'}));
  yield takeEvery('DELETE.COMMUNICATION_BACKGROUND_FILE.REQUEST', action => deleteFile({...action, genericAction: 'DELETE.COMMUNICATION_BACKGROUND_FILE'}));
}



// WEBPACK FOOTER //
// ./src/sagas/upload.js